// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"9e4ed512","193":"aaeb9e8f","216":"5d46bf8c","475":"dcf7bb1a","533":"1726290a","669":"07fcc093","773":"6a3c68c3","888":"e5d80740","925":"4f2fe926","986":"1bb62644"}[chunkId] + ".chunk.js";
};